import angular from 'angular';
import autocompleteComponent from './company-autocomplete.component';

export default angular.module('common.autocomplete.company', [])
  .component('companyAutocomplete', autocompleteComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/common/autocomplete/company/company-autocomplete.module.js